import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';
import { useModel } from '@umijs/max';

const Footer: React.FC = () => {
  const { initialState } = useModel('@@initialState');
  return (
    <DefaultFooter
      style={{
        background: 'none',
        marginTop: 'auto', // 确保Footer自动推到页面底部
      }}
      links={[
        {
          key: initialState?.branding?.name || '中福通（东莞）',
          title: initialState?.branding?.name || '中福通（东莞）',
          href: initialState?.branding?.homeLink || 'https://zftdg.com',
          blankTarget: true,
        },
      ]}
      copyright={initialState?.branding?.copyright || '© 中福通（东莞）'}
    />
  );
};

export default Footer;
